import { useState } from "react"
import { Box, Typography, IconButton, Grid, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { WeekMenuProduct } from "../../../weekMenuTypes"
import { StandardDialog } from "../../../../../../../shared/components/dialogs/StandardDialog"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { ProductCard } from "./ProductCard"

const ChevronLeftIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
        <path
            d="M10.5 3L5.5 8L10.5 13"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
        />
    </svg>
)

const ChevronRightIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
        <path
            d="M5.5 3L10.5 8L5.5 13"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
        />
    </svg>
)

const useStyles = makeStyles()(() => ({
    dialogPaper: {
        background: "white",
        borderRadius: ".75rem",
    },
    carousel: {
        padding: "3.5rem 2rem 2rem 2rem",
        display: "flex",
        alignItems: "start",
        justifyContent: "center",
        gap: "1.5rem",
        width: "100%",
    },
    button: {
        marginTop: "8rem",
        borderRadius: ".625rem",
        color: "#1E293B",
        backgroundColor: "white",
        border: "1px solid #E2E8F0",
        width: "2rem",
        height: "2rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:disabled": {
            backgroundColor: "#E2E8F0",
            border: "1px solid #CBD5E1",
            cursor: "not-allowed",
        },
    },
    header: {
        padding: "0 2rem",
        gap: "0.5rem",
    },
}))

type TodaysOfferDetailsProps = {
    isOpen: boolean
    imageMode: "none" | "mixed" | "unknown"
    onClose: () => void
    displayDate: string
    weeklyOffers?: WeekMenuProduct[] | null
}

export function TodaysOfferDetails({ isOpen, imageMode, onClose, weeklyOffers, displayDate }: TodaysOfferDetailsProps) {
    const { classes } = useStyles()
    const [activeIndex, setActiveIndex] = useState(0)

    if (!weeklyOffers?.length) return null

    const itemsPerPage = 3
    const totalSlides = Math.ceil(weeklyOffers.length / itemsPerPage)

    const handleNext = () => {
        if (activeIndex < totalSlides - 1) {
            setActiveIndex(activeIndex + 1)
        }
    }

    const handlePrev = () => {
        if (activeIndex > 0) {
            setActiveIndex(activeIndex - 1)
        }
    }

    const startIndex = activeIndex * itemsPerPage
    const visibleItems = weeklyOffers.slice(startIndex, startIndex + itemsPerPage)

    return (
        <StandardDialog
            // slotProps={{ paper: { className: classes.dialogPaper } }}
            // maxWidthProp="lg"
            scroll={"body"}
            isFullScreen
            open={isOpen}
            onClose={onClose}
        >
            <Stack className={classes.header} direction="row" alignItems="baseline">
                <LocalizedStrict id="user-home-week-menu-dialog-title">
                    <Typography color="#000000DE" variant="h4">
                        Todays menu
                    </Typography>
                </LocalizedStrict>
                <Typography variant="h6" fontWeight={500} color="#00000099">
                    {displayDate}
                </Typography>
            </Stack>
            <Box className={classes.carousel}>
                {totalSlides > 1 && (
                    <IconButton className={classes.button} onClick={handlePrev} disabled={activeIndex === 0}>
                        <ChevronLeftIcon />
                    </IconButton>
                )}

                <Grid container spacing={4}>
                    {visibleItems.map((offer) => (
                        <Grid item xs={12} sm={4} key={offer.id}>
                            <ProductCard onlyView extendDetails imageMode={imageMode} resource={offer} />
                        </Grid>
                    ))}
                </Grid>

                {totalSlides > 1 && (
                    <IconButton
                        className={classes.button}
                        onClick={handleNext}
                        disabled={activeIndex >= totalSlides - 1}
                    >
                        <ChevronRightIcon />
                    </IconButton>
                )}
            </Box>
        </StandardDialog>
    )
}
